<template>
  <div>
    <el-row class="query">
      <el-select v-model="queryObj.teamId" placeholder="选择车队">
        <el-option v-for="team in teams" :key="team.id" :label="team.name" :value="team.id">
        </el-option>
      </el-select>
      &nbsp;&nbsp;
      <el-button @click.native="query">查询</el-button>
    </el-row>
    <el-table :data="learns" style="width: 100%">
      <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
      <el-table-column sortable prop="no" label="班号" width="180"> </el-table-column>
      <el-table-column sortable prop="uptime" label="最后学习时间"> </el-table-column>
      <el-table-column sortable prop="undones" label="未观看个数"> </el-table-column>
      <el-table-column sortable prop="lRate" label="观看进度"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "VedioStat",
  data() {
    return {
      queryObj: { teamId: "" },
      teams: [],
      learns: []
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.$http.post("/admin/train/stat/initexbank", {}).then((res) => {
        this.teams = res.data.teams || [];
        this.queryObj.teamId = this.teams[0].id;
      });
    },
    query() {
      let url = "/admin/train/stat/vedio";
      this.$http.post(url, this.queryObj).then((res) => {
        this.learns = res.data || [];
      });
    }
  }
};
</script>

<style scoped>
.query {
  margin-top: 24px;
  margin-bottom: 24px;
  text-align: right;
}
</style>
